/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MagnifyingGlassMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABz0lEQVR4nMVUy0pcQRBt1zq6isGtC12qWSokKCgDTldVC32rfPyJxj/RD1D8BsXHTjc64OsLHCFKFF0mVPcdJxFue684WNAw3Kmuc6pO9THms6JBPGeRNyzJBSA/W5QHILkO35zMvLswEY8A8gGQ/Eke5IP5haXhSsUBsu9A/EsLWOQbIF5FXBqfnV3p1QMgE0CyFv/THLm3C9lUeeZ5cUDZAoBaMRGoWeLtAEJ8B+BH32bfHgvKljGmpwSnng6I7CbvqKAvY0kwfx31+nI/oLQCMcimTVHoZkTxeLUwqSAs8s+c3EZRjrEol5o077IxUzEgCq/kmimAp9hmZzyW5Ci1oh0AqOUAjymAh9cAqbdgSfb/0yF++13cJvKVJunOd2lEnIssa5UBiNfzDjaLAZzMvGdNvfcDQHyrdxu0+CPNJJ+5Pp6yDw1QdnLR9968o8al3tIGUfGSzNvFg3Y8WYKQMWpcwVuiZbT0ETVc9s1736dHf8eZx7F01lbOnFsZLAWixqXeUsKu95S5Fq8MEuYL2XTcLm5Glw2nqdvyr6Ba9AWEuFkFpHTUvf9iiU/zzs6dWx76cBCnnYRuw5Icm26EtfIVUE4A5bArAJ8SfwFLHTf/CkN2qQAAAABJRU5ErkJggg==)
 */
export const MagnifyingGlassMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M15.62 17.03a9 9 0 1 1 1.41-1.41l4.68 4.67a1 1 0 0 1-1.42 1.42l-4.67-4.68ZM17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M6 10a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
